
<template>
    <header class="header">
        <template v-if="isAuthenticated">
            <transition name="fade-in" mode="out-in">
                <FormSearch v-if="$route.path !== '/dashboard'" />
                <h1 v-else style="margin-bottom: 0;">Hi {{ user.name | titleCase }}!</h1>
            </transition>

            <nav class="account__actions">
                <Button display="link" @click="logoutUser">Logout <SVGicon-logout class="icon--logout" /></Button>
            </nav>
        </template>

        <Button display="link" v-else @click="$router.push({ name: 'login' })" role="link" style="display: flex; align-items: center;">
            <SVGlink-arrow style="transform: rotate(180deg); margin-right: 1em;" /> Back to login
        </Button>
    </header>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { toTitleCase } from '@/helpers'

export default {
    filters: {
        titleCase (val) {
            return toTitleCase(val)
        }
    },

    computed: {
        ...mapState('Auth', ['user']),
        ...mapGetters('Auth', ['isAuthenticated'])
    },

    methods: {
        ...mapActions('Auth', ['logoutUser'])
    }
}
</script>

